import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of, throwError } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { CommonService } from 'src/app/component/shared/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.scss'],
})
export class NewServiceComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NewServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private fb: FormBuilder,
    private _commonService: CommonService,
    private _snackbar: MatSnackBar
  ) {}
  form: FormGroup;
  isSubmitLoading = false;

  ngOnInit() {
    this.form = this.fb.group({
      routeId: new FormControl('', [
        Validators.required,
        Validators.maxLength(25),
      ]),
      // routeLongName: new FormControl('', [
      //   Validators.required,
      //   Validators.maxLength(255),
      // ]),
      loop: new FormControl(false),
      // routeShortName: new FormControl('', [Validators.maxLength(100)]),
    });
  }

  onCloseModal(): void {
    this.dialogRef.close();
  }

  onSave() {
    if (this.isSubmitLoading) return;
    this.isSubmitLoading = true;
    const { routeId, routeLongName, loop } = this.form.value;
    const apiData = {
      routeLists: [
        {
          routeId,
          routeLongName: '',
        },
      ],
    };
    const agencyId = '11';
    const serviceUrlAction =
      environment.apiUrl.gtfs + `/v1/createRoutes/${agencyId}`;
    const createService = this._commonService.commonPostFullUrlAction(
      serviceUrlAction,
      apiData
    );

    const routeApiData = loop
      ? {
          routeId,
          navigation: [
            {
              direction: 1,
              path: null,
              stops: [],
            },
          ],
        }
      : {
          routeId,
          navigation: [
            {
              direction: 1,
              path: null,
              stops: [],
            },
            {
              direction: 2,
              path: null,
              stops: [],
            },
          ],
        };
    const routeUrlAction =
      environment.apiServerGtfsUrl + 'v1/createServiceRoute';

    const createRoute = this._commonService.commonPostFullUrlAction(
      routeUrlAction,
      routeApiData,
      'text'
    );

    const createServiceOperation$ = createService.pipe(
      take(1),
      switchMap(createRouteResponse => {
        if (createRouteResponse) {
          return createRoute.pipe(
            take(1),
            switchMap(createServiceResponse => {
              if (createServiceResponse) {
                return of({ createRouteResponse, createServiceResponse });
              } else {
                return throwError({
                  message: 'Failed to create service',
                });
              }
            })
          );
        } else {
          return throwError({
            message: 'Failed to create service',
          });
        }
      })
    );

    createServiceOperation$.subscribe({
      next: res => {
        console.log(res);
        if (res) {
          this._snackbar.open(`Route ${routeId} has been created.`, null, {
            duration: 3000,
          });
          this.dialogRef.close({
            newRoute: true,
            routeId,
            routeLongName,
          });
        } else {
          this._snackbar.open(
            'Failed to create service. Please try again.',
            null,
            {
              duration: 5000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
        }
        this.isSubmitLoading = false;
      },
      error: err => {
        this.isSubmitLoading = false;
        console.error(err);
        const errorMessage =
          err.error.message?.split('[')?.[0] ||
          err.error.error ||
          'Please try again.';
        this._snackbar.open('Error: ' + errorMessage, null, {
          duration: 5000,
          panelClass: 'custom-snack-bar-panel-error',
        });
      },
    });
  }
}
